export const clearOrder = (order) => {
    console.log('clearOrder order', order)
    return {
        ...order,
        rdoId: order.codiceRDO,
        orderDetail: order.dettaglioOrdine,
        orderRequest: {
            templateRDO: order.codiceTemplateRDO,
        },
    }
}
